import "../css/ProductImageCarousel.scss";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import "swiper/css/bundle";
import { useState } from "react";

const ProductImagesSlider = (props) => {
	return (
		<>
			<Swiper
				loop={false}
				spaceBetween={20}
				navigation={true}
				modules={[Navigation, Thumbs]}
				grabCursor={true}
				// thumbs={{ swiper: activeThumb }}
				className="product-images-slider"
			>
				{props.imageArray.map((item, index) => (
					<SwiperSlide key={index}>
						<img src={item.url} alt="product images" />
					</SwiperSlide>
				))}
			</Swiper>
		</>
	);
};

ProductImagesSlider.propTypes = {
	images: PropTypes.array.isRequired,
};

export default ProductImagesSlider;
